import { cn } from "~/lib/utils";
import { JLPT_TEXT_WEIGHTS } from "~/server/db/videos/constants";

export const JLPTBadge = ({
  level,
  className,
  variant = "default",
}: {
  level: number | "*" | undefined;
  className?: string;
  variant?: "default" | "menu";
}) => {
  if (!level) return null;
  return (
    <span
      className={cn(
        "rounded-md bg-muted font-medium text-muted-foreground",
        variant === "default" && "px-2 py-1 text-xs",
        variant === "menu" &&
          "flex h-4 w-4 items-center justify-center px-1 text-[12px]",
        JLPT_TEXT_WEIGHTS[level as keyof typeof JLPT_TEXT_WEIGHTS],
        className,
      )}
    >
      N{level}
    </span>
  );
};
